var Copy = {};
var Alert = require('../components/alert');
Copy.init = function () {
  var elements = $(document).find('.js-copy');
  if (!elements) return;
  elements.on('click', function (e) {
    e.preventDefault();
    var copyText = this.dataset.text;
    if (copyText) {
      Copy.copyToClipboard(copyText);
      Alert.show('success', this.dataset.alert, this.dataset.btn);
    }
  });
};
Copy.copyToClipboard = function (textToCopy) {
  var textArea;
  function isOS() {
    return navigator.userAgent.match(/ipad|iphone/i);
  }
  function createTextArea(text) {
    textArea = document.createElement('textArea');
    textArea.readOnly = true;
    textArea.contentEditable = true;
    textArea.value = text;
    document.body.appendChild(textArea);
  }
  function selectText() {
    var range, selection;
    if (isOS()) {
      range = document.createRange();
      range.selectNodeContents(textArea);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }
  }
  function copyTo() {
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
  createTextArea(textToCopy);
  selectText();
  copyTo();
};
Copy.init();


// WEBPACK FOOTER //
// ./scripts/components/copy.js